import { createAction } from '@reduxjs/toolkit';

// Lives in its own module, not in `store/index.ts`: `userSlice` needs to react
// to it, and `store/index.ts` imports every slice — importing back would be a
// cycle.
//
// Dispatched by `Topbar.handleLogout` BEFORE it hands off to Keycloak.
// `store/index.ts`'s root reducer turns it into a whole-store wipe (every slice
// falls back to its initial state), and `userSlice` additionally latches
// `status: 'loggedOut'` on top of that — see the note there.
export const loggedOut = createAction('auth/loggedOut');
